import { readFactoryList } from '@/api/asset/factory/read';
import Header from '@/component/Header';
import { FactoryListTableColumns } from '@/component/pools/table/ColumnsData';
import { Tables } from '@/component/pools/table/Tables';
import { ShortenAddr } from '@/lib/Shorten';
import { Box, Card, CardContent, Divider } from '@mui/material';
import { useEffect, useState } from 'react';

type ResFactoryListType = {
  adminAddress: string;
  contractAddr: string;
  description: string | null;
  factoryId: string;
  network: string;
  regDt: string;
  title: string | null;
  index: string;
};

export default function FactoryList() {
  const [list, setList] = useState<ResFactoryListType[] | null>(null);
  useEffect(() => {
    (async () => {
      const re = await readFactoryList();
      console.log(re);
      if (re.status !== 200) {
        return;
      }
      const list = re.data.map((item: ResFactoryListType) => {
        const obj = {
          ...item,
          shortAddress: ShortenAddr(item.adminAddress),
          shortContractAddr: ShortenAddr(item.contractAddr),
          index: item.factoryId,
          description: item?.description ? item?.description : '',
        };
        return obj;
      });
      setList(list);
    })();

    return () => {};
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="팩토리 리스트" />
        <Divider />
        <CardContent>
          {list && <Tables list={list} columns={FactoryListTableColumns} navigateUrl={'/factory-detail'} />}
        </CardContent>
      </Card>
    </Box>
  );
}
